import React from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';




import { WalletProvider } from './context/WalletContext'; // WalletProvider import करें



import ConnectWallet from './components/Connectwallet';
import Mainsection from './components/Mainsection';
import Swap from './components/SwapToken';


function App() {
  return (
    <WalletProvider> {/* WalletProvider के साथ wrap करें */}
      <Router>
        <div className="App">
          <Header />
       
  
          <Routes>
            
            <Route path="/" element={<Mainsection />} />
            <Route path="/connect-wallet" element={<ConnectWallet />} />
            <Route path="/swaptoken" element={<Swap/>} />
    
       
          </Routes>
          <Footer />
        </div>
      </Router>
    </WalletProvider>
  );
}

export default App;
